<div class="item" [class.item--locked]="!skill.importable">
  <nb-checkbox
    *ngIf="mode === 'checkbox'"
    [checked]="checked"
    [disabled]="!skill.importable"
    (checkedChange)="checkedChange.emit($event)"
    [nbTooltip]="(skill.importable ? 'pages.skills.library.tooltips.select' : 'pages.skills.library.tooltips.locked') | translate"
  ></nb-checkbox>
  <div class="item__main">
    <div class="item__head">
      <strong class="item__name">{{ skill.name }}</strong>
      <span class="badge" [class.badge--muted]="!skill.importable"
        [nbTooltip]="(skill.importable ? 'pages.skills.library.tooltips.license' : 'pages.skills.library.tooltips.locked') | translate">
        {{ skill.license === "proprietary" ? ("pages.skills.library.proprietary" | translate)
           : skill.license === "unknown" || !skill.license ? ("pages.skills.library.licenseUnknown" | translate)
           : skill.license }}
      </span>
      <span class="badge badge--warn" *ngIf="skill.needs_code" [nbTooltip]="'pages.skills.library.tooltips.needsCode' | translate">
        {{ "pages.skills.library.needsCode" | translate }}
      </span>
      <span class="item__source" *ngIf="sourceLabel">{{ sourceLabel }}</span>
    </div>
    <p class="item__desc">{{ skill.description }}</p>
  </div>
  <div class="item__actions">
    <a class="al-icon-button" [href]="skill.url" target="_blank" rel="noopener noreferrer"
      [nbTooltip]="'pages.skills.library.tooltips.source' | translate">
      <nb-icon icon="github-outline"></nb-icon>
    </a>
    <button *ngIf="mode === 'button'" nbButton size="small" status="primary" type="button"
      [disabled]="!skill.importable || busy" (click)="importClick.emit(skill)"
      [nbTooltip]="(skill.importable ? 'pages.skills.library.tooltips.import' : 'pages.skills.library.tooltips.locked') | translate">
      {{ "pages.skills.library.import" | translate }}
    </button>
  </div>
</div>
